<template>
<div v-show="currentTrack" :class="{'pp-mobile-nowplaying':1, 'pp-mobile-nowplaying--expanded': expanded }">
    <input ref="seekbarMini" data-seekbar-fix type="range" min="0" max="100" step="0.001" :value="playbackPosition" data-seekbar-fix class="pp-seekbar pp-seekbar--subtle-thumb pp-mobile-nowplaying__seekbar">
    <div v-if="currentTrack" class="pp-mobile-nowplaying__main">
        <button type="button" @click="toggle" class="pp-mobile-nowplaying__toggle">
            <i class="fa fa-fw fa-angle-up"></i>
        </button>
        <div @click="toggle" class="pp-mobile-nowplaying__info">
            <div class="pp-mobile-nowplaying__track">
                {{ currentTrack.title }}
            </div>
            <div v-if="currentTrack.album" class="pp-mobile-nowplaying__artist">
                {{ currentTrack.album.title }}
            </div>
        </div>
        <div class="pp-mobile-nowplaying__play">
            <i @click="play" :class="{'fa':1, 'fa-fw':1, 'fa-play': !playing , 'fa-pause': playing}"></i>
        </div>
    </div>


    <div class="pp-mobile-nowplaying__full">
        <div  v-if="currentTrack" class="pp-mobile-nowplaying__full__header">
            <button type="button" @click="toggle" class="pp-mobile-nowplaying__toggle">
                <i class="fa fa-fw fa-angle-down"></i>
            </button>
            <div @click="toggle"v-if="currentTrack.album" class="pp-mobile-nowplaying__album">
                {{ currentTrack.album.title }}
            </div>
            <div class="pp-mobile-nowplaying__queue" style="opacity: 0">
                <i class="fa fa-fw fa-indent"></i>
            </div>
        </div>
        <mobile-cover-art-slider
             :href="'https://www.pristineclassical.com/products/'+((currentTrack && currentTrack.album) ? currentTrack.album.code.toLowerCase() : '')"
             :current-track="currentTrack"/>
        <div class="pp-mobile-nowplaying__controls">
            <div class="pp-mobile-nowplaying__controls__position">
                <label class="pp-mobile-nowplaying__controls__position__label">
                    {{ playbackPositionSeconds|duration }}
                </label>
                <input type="range" min="0" max="100" ref="seekbar" step="0.001"
                        :value="controls.seeking ? controls.position : playbackPosition"
                        data-seekbar-fix class="pp-seekbar">
                <label class="pp-mobile-nowplaying__controls__position__label">
                    {{ playbackDuration|duration }}
                </label>
            </div>
            <div v-if="currentTrack" class="pp-mobile-nowplaying__info">
                <div class="pp-mobile-nowplaying__track">
                    {{ currentTrack.title }}
                </div>
                <div v-if="currentTrack.album" class="pp-mobile-nowplaying__artist">
                    {{ currentTrack.album.title }}
                </div>
            </div>
            <div class="pp-mobile-nowplaying__controls__primary">
                <button @click="backward" type="button" class="pp-mobile-nowplaying__controls__button">
                    <i class="fa fa-fw fa-backward"></i>
                </button>
                <button @click="play" type="button" class="pp-mobile-nowplaying__controls__button pp-mobile-nowplaying__controls__button--primary">
                    <i :class="{'fa':1, 'fa-fw':1, 'fa-play': !playing , 'fa-pause': playing}"></i>
                </button>
                <button @click="forward" type="button" class="pp-mobile-nowplaying__controls__button">
                    <i class="fa fa-fw fa-forward"></i>
                </button>
            </div>
            <div class="pp-mobile-nowplaying__controls__volume">
                <label class="pp-mobile-nowplaying__controls__volume__label">
                    <i class="fa fa-fw fa-volume-off"></i>
                </label>
                <input v-model="controls.volume" data-seekbar-fix type="range" min="0" max="100" value="70" class="pp-seekbar">
                <label class="pp-mobile-nowplaying__controls__volume__label">
                    <i class="fa fa-fw fa-volume-up"></i>
                </label>
            </div>
            <div class="pp-mobile-nowplaying__controls__secondary">
                <button @click="toggleRepeat"
                        type="button"
                        :class="{'pp-mobile-nowplaying__controls__button':1, 'pp-mobile-nowplaying__controls__button--active': controls.repeat}">
                    <i class="fa fa-fw fa-refresh"></i>
                </button>
                <button @click="toggleShuffle"
                        type="button"
                        :class="{'pp-mobile-nowplaying__controls__button':1, 'pp-mobile-nowplaying__controls__button--active': controls.shuffle}">
                    <i class="fa fa-fw fa-random"></i>
                </button>
                <!--
                <button @click="toggleRepeat"
                        type="button"
                        :disabled="!controls.castEnabled"
                        :class="{'pp-mobile-nowplaying__controls__button':1}">
                    <i class="fa fa-fw fa-podcast"></i>
                </button>
                -->

                <div class="pp-mobile-nowplaying__controls__quality">
                    <div class="pp-mobile-nowplaying__controls__quality__label">
                        MP3
                    </div>
                    <input :disabled="!enableFlac || !enableFlacTrack" v-model.number="flacInput" :debug.number="flacInput" data-seekbar-fix class="pp-seekbar pp-seekbar--togglebutton" type="range" max="1" min="0" value="1">
                    <div class="pp-mobile-nowplaying__controls__quality__label">
                        FLAC
                    </div>
                    <div v-if="!enableFlac" class="pp-mobile-nowplaying__controls__quality__disabled pp-playbar__quality__disabled--device"
                         title="To enable FLAC playback, please use a modern browser such as Chrome or Firefox.">
                        Not supported by your device.
                    </div>
                    <div v-if="enableFlac && !enableFlacTrack" class="pp-mobile-nowplaying__controls__quality__disabled pp-playbar__quality__disabled--device"
                         title="Unfortunately we don't have a copy of this track in FLAC at the yet.">
                        Not available for this track.
                    </div>
                </div>
            </div>
        </div>
        <a v-if="!$root.isIos" class="pp-mobile-nowplaying__buy-button"
             v-show="currentTrack && currentTrack.album"
             @click="buyItLink"
             target="_blank">
            Notes / Buy now
        </a>
    </div>
</div>
</template>


<script>
import Vue from 'vue';
import EventBus from '../EventBus.js';

import MobileCoverArtSlider from './MobileCoverArtSlider.vue';

export default {
    name: 'mobile-now-playing',
    components: {
        MobileCoverArtSlider,
    },
    data() {
        return {
            controls: {
                repeat: true,
                shuffle: false,
                cast: false,
                castEnabled: false,
                showQueue: false,

                seeking: false,
                position: 0,
                volume: 33,
                flac: true
            },
        };
    },
    props: {
        enableFlac: Boolean,
        enableFlacTrack: Boolean,
        playing: Boolean,
        currentTrack: Object,
        playbackPosition: Number,
        playbackPositionSeconds: Number,
        playbackDuration: Number,
        queue: Array,
        history: Array,

        expanded: Boolean,
    },
    computed: {
        flacInput: {
            get() {
                return this.controls.flac ? 1 : 0;
            },
            set(value) {
                this.controls.flac = value == 1;
            }
        },
        nearHistory() {
            var r = [];
            var i = 0;
            for (var item of this.history) {
                i++;
                if (i > 3) { break; }
                r.push(item);
            }
            return r;
        },
        nearQueue() {
            var r = [];
            var i = 0;
            for (var item of this.queue) {
                i++;
                if (i > 3) { break; }
                r.push(item);
            }
            return r;
        }
    },
    mounted() {
        if (!this.enableFlac && this.controls.flac) {
            this.controls.flac = false;
        }

        EventBus.on('controls.setVolume', (e) => {
            if (e.data.volume != this.controls.volume) {
                this.controls.volume = e.data.volume;
            }
        });

        EventBus.on('controls.setQuality', (e) => {
            if (e.data.flac != this.controls.flac) {
                this.controls.flac = e.data.flac;
            }
        });

        this.$refs.seekbar.addEventListener('input', (e) => {
            this.controls.seeking = true;
            this.controls.position = e.target.value;
        });

        this.$refs.seekbar.addEventListener('change', (e) => {
            this.controls.seeking = false;

            EventBus.emit('controls.setPosition', {
                position: e.target.value,
                type: 'seek'
            });
        });
    },
    methods: {
        buyItLink() {
            const productUrl = "https://www.pristineclassical.com/products/" + ((this.currentTrack && this.currentTrack.album) ? this.currentTrack.album.code.toLowerCase() : '');
            if (this.$root.isIos) {
                window.location.href = productUrl;
            } else {
                window.open(productUrl, '_blank');
            }
        },
        toggle() {
            console.log('toggle');
            EventBus.emit('mobile.toggleNowPlaying', {});
        },
        toggleRepeat () {
            console.log(this.controls);
            this.controls.repeat = !this.controls.repeat;
            EventBus.emit('controls.playModeChanged', {
                repeat: this.controls.repeat,
                shuffle: this.controls.shuffle
            });
        },
        toggleQuickQueue() {
            this.controls.showQueue = !this.controls.showQueue;
            if (this.controls.showQueue) {
                Vue.nextTick(() => {
                    if (this.quickQueueTether) {
                        this.quickQueueTether.position();
                    }
                });
            }
        },
        toggleShuffle() {
            this.controls.shuffle = !this.controls.shuffle;
            EventBus.emit('controls.playModeChanged', {
                repeat: this.controls.repeat,
                shuffle: this.controls.shuffle
            });
        },
        play() {
            EventBus.emit('controls.togglePause', {});
        },
        forward() {
            EventBus.emit('controls.next', {});
        },
        backward() {
            EventBus.emit('controls.previous', {});
        },
    },
    watch: {
        'currentTrack': function() {
        },
        'controls.flac': function flac() {
            if (this.controls.flac && !this.enableFlac) {
                this.controls.flac = false;
            }
            EventBus.emit('controls.setQuality', {
                flac: this.controls.flac == true
            });
        },
        'enableFlac': function enableFlac() {
            if (!this.enableFlac && this.controls.flac) {
                this.controls.flac = false;
                this.$emit('controls.setQuality', {
                    flac: this.controls.flac == true
                });
            }
        },
        'playbackPosition': function playbackPosition() {
            var e = new Event('seekbar.update');
            this.$refs.seekbar.dispatchEvent(e);

            var e = new Event('seekbar.update');
            this.$refs.seekbarMini.dispatchEvent(e);
        },
        'controls.position': function position() {
            var e = new Event('seekbar.update');
            this.$refs.seekbar.dispatchEvent(e);

            var e = new Event('seekbar.update');
            this.$refs.seekbarMini.dispatchEvent(e);
        },
        'controls.volume': function volume() {
            EventBus.emit('controls.setVolume', {
                volume: this.controls.volume
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// MobileNowPlaying.vue?2fed4aef